
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.286 1.714v8H10.57a.857.857 0 00-.857.857v3.715h-8V1.714h12.572zm-2.857 12.433v-2.719h2.718l-2.718 2.719zM16 11.29V1.714C16 .768 15.233 0 14.286 0H1.714C.767 0 0 .768 0 1.714v12.572C0 15.232.767 16 1.714 16h9.576c.455 0 .89-.18 1.212-.502l2.996-2.996c.321-.321.502-.758.502-1.212z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    